import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import CircleIcon from '@mui/icons-material/Circle';
import type { MarkerProps } from './interfaces';
import type { SvgIconProps } from '@mui/material';

const useStyles = makeStyles({ name: 'Dot' })(() => ({
  root: {
    position: 'absolute',
    height: 10,
    width: 10,
    left: -5,
    top: -5,
  },
}));

export const Dot = memo<MarkerProps & SvgIconProps>(({ zIndex, ...restProps }) => {
  const { classes } = useStyles();

  return (
    <CircleIcon
      className={classes.root}
      color="error"
      {...restProps}
    />
  );
});

export default Dot;
